import type { AccountRole } from '@packages/types';

/**
 * The display label for every account role, in one place.
 *
 * The sidebar's account block and the Settings -> Team table both name a
 * member's role, and they drifted the moment a new role was added: two copies
 * of the same map means one of them is updated and the other keeps rendering
 * the old fall-through. Being a `Record<AccountRole, string>` is the point -
 * the next role added fails to compile here rather than silently displaying as
 * something else.
 *
 * The admin app keeps its own map deliberately: cross-app UI imports are banned,
 * so that copy is correct rather than a third duplicate to fold in.
 */
export const ACCOUNT_ROLE_LABELS: Record<AccountRole, string> = {
  owner: 'Owner',
  'super-admin': 'Super Admin',
  assistant: 'Assistant',
  bookkeeper: 'Bookkeeper',
  member: 'Member',
  'ai-assistant': 'AI Assistant',
};
